import React, { useEffect, useState } from "react";
import { GET_ALL_USERS, GET_LANGUAGES_INFO } from "../../../api";
import DashboardChart from "../../../components/DashboardChart";
import DashboardTable from "../../../components/DashboardTable";
import { DashboardCss } from "../../../styles/dashboard";

import profileIcon from "../../../assets/images/img_avatar.png";

const Dashboard = () => {
  const [languagesArray, setLanguageArray] = useState([]);

  const [data, setData] = useState([
    { name: "JavaScript", value: 950 },
    { name: "Python", value: 300 },
    { name: "C", value: 300 },
    { name: "Java", value: 200 },
    { name: "Others", value: 200 },
  ])

  const [jsValue, setJsValue] = useState(0);
  const [pyValue, setPyValue] = useState(0);
  const [cValue, setCValue] = useState(0);
  const [javaValue, setJavaValue] = useState(0);
  const [otherValue, setOtherValue] = useState(0);

  const [firstName, setFirstName] = useState("");
  const [secondName, setSecondName] = useState("");
  const [thirdName, setThirdName] = useState("");

  const [firstScore, setFirstScore] = useState("");
  const [secondScore, setSecondScore] = useState("");
  const [thirdScore, setThirdScore] = useState("");

  const [tableData, setTableData] = useState([]);

  const checkHandler = async () => {
    const response = await fetch(
      "http://20.204.99.128/devai/api/Answer/GetLanguage"
    );
    const jsonData = await response.json();
    console.log(jsonData);
  };

  useEffect(() => {
    GET_ALL_USERS()
      .then((e) => {
        console.log("All users: ", e);
        let res = e.data;

        res = res.sort((a, b) => b.coins - a.coins)

        let resTableData = [];

        setFirstName(`${res[0].firstName} ${res[0].lastName}`);
        setSecondName(`${res[1].firstName} ${res[1].lastName}`);
        setThirdName(`${res[2].firstName} ${res[2].lastName}`);

        setFirstScore(`${res[0].coins}`);
        setSecondScore(`${res[1].coins}`);
        setThirdScore(`${res[2].coins}`);

        for (let i=3; i<res.length; i++) {
            let tableObj = {
                firstName: res[i].firstName,
                lastName: res[i].lastName,
                rank: i+1,
                score: res[i].coins,
            }

            resTableData.push(tableObj);
        }

        setTableData(resTableData);
      })
      .catch((er) => {
        console.log("all user Error: ", er);
      });
    // checkHandler();
  }, []);

  useEffect(() => {
    GET_LANGUAGES_INFO()
      .then((e) => {
        console.log("All languaages: ", e);

        let res = e.data;
        let otherCount = 0;

        let changedData = [
            { name: "JavaScript", value: 0 },
            { name: "Python", value: 0 },
            { name: "C", value: 0 },
            { name: "Java", value: 0 },
            { name: "Others", value: 0 },
          ]

        for (let i=0; i<res.length; i++) {
            if (res[i].pLanguage == "JavaScript") {
                setJsValue(Number(res[i].numberOfRequest));
                changedData[0].value = Number(res[i].numberOfRequest);
            }
            else if (res[i].pLanguage == "c") {
                setCValue(Number(res[i].numberOfRequest));
                changedData[2].value = Number(res[i].numberOfRequest);
            }
            else if (res[i].pLanguage == "Java") {
                setJavaValue(Number(res[i].numberOfRequest));
                changedData[3].value = Number(res[i].numberOfRequest);
            }
            else if (res[i].pLanguage == "python") {
                setPyValue(Number(res[i].numberOfRequest));
                changedData[1].value = Number(res[i].numberOfRequest);
            } else {
                otherCount += Number(res[i].numberOfRequest); 
            }
        }

        setOtherValue(otherCount);
        changedData[4].value = otherCount;

        setData(changedData);
      })
      .catch((er) => {
        console.log("Lan Error: ", er);
      });
  }, []);

  return (
    <>
      <DashboardCss />
      <div className="parent-container">
        <div className="chart-container">
          <DashboardChart data={data} />
          {data.map((e) => {
            return (
              <div className="chart-content">
                <div className="chart-content-head">{e.name}</div>
                <div className="chart-content-body">{e.value}</div>
              </div>
            );
          })}
        </div>
        <div className="leaderborad-table">
          <div className="top3-container">
            <div class="secondCard">
              <img src={profileIcon} alt="Avatar" className="avatar" />
              <div class="container">
                <h4>
                  <b>{secondName}</b>
                </h4>
                <p>
                  <b>Score: </b>{secondScore}
                </p>
              </div>
              <div className="rank">2nd</div>
            </div>
            <div class="firstCard">
              <img src={profileIcon} alt="Avatar" className="avatar" />
              <div class="container">
                <h4>
                  <b>{firstName}</b>
                </h4>
                <p>
                  <b>Score: </b>{firstScore}
                </p>
              </div>
              <div className="rank">1st</div>
            </div>
            <div class="thirdCard">
              <img src={profileIcon} alt="Avatar" className="avatar" />
              <div class="container">
                <h4>
                  <b>{thirdName}</b>
                </h4>
                <p>
                  <b>Score: </b>{thirdScore}
                </p>
              </div>
              <div className="rank">3rd</div>
            </div>
          </div>
          <DashboardTable tableData={tableData} />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
